// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3-1IK","dragIcon":"Choice_dragIcon__2UXVJ","left":"Choice_left__p3-rG","input":"Choice_input__1BCzW"};